










import Vue from "vue";
import Component from "vue-class-component";
@Component
export default class CycleSelector extends Vue {
	selected = 1;

	options = [{
		value: '选项1',
		label: '黄金糕'
	}, {
		value: '选项2',
		label: '双皮奶'
	}, {
		value: '选项3',
		label: '蚵仔煎'
	}, {
		value: '选项4',
		label: '龙须面'
	}, {
		value: '选项5',
		label: '北京烤鸭'
	}, {
		value: '选项6',
		label: '北京烤鸭'
	}, {
		value: '选项7',
		label: '北京烤鸭'
	}, {
		value: '选项8',
		label: '北京烤鸭'
	}, {
		value: '选项9',
		label: '北京烤鸭'
	}, {
		value: '选项10',
		label: '北京烤鸭'
	}];
	value= '';

}
